module.exports = __webpack_public_path__ + "d4ffba5ac20034cd9d7a3b755d277bbd.jpg";